export default __webpack_public_path__ + "static/media/thunderclap.556be119.png";